import React, {useEffect, useState} from "react";
import "../../sass/main.scss";
import CmnCard from "../CmnCard";
import $ from 'jquery';
import axios2 from "../../helpers/APIHelper";
import Paging from "../common/Paging";

import caretLeftFill from "../../images/caret-left-fill.svg";
import caretRightFill from "../../images/caret-right-fill.svg";
import axios from "axios";
import Fn from "../../libraries/Fn";
import JDatePicker from "../common/JDatePicker";

const MemberDelayList = (props) => {

  window._load = (_page = 1) => {
    try {
      load(_page);
    } catch (e) {
    }
  }

  const [rets, setRets] = useState([]);
  const [pageInfo, setPageInfo] = useState({});
  const [currPage, setCurrPage] = useState(1);
  const [renew, setRenew] = useState(0);

  useEffect(() => {
    $('.fn_search_box').each(function () {
      $(this).find("input[type=text]").each(function () {
        $(this).onEnter(() => setRenew(Fn.getRenewTime));
      });
    });
  }, []);

  useEffect(() => {
    load();
  }, [currPage, renew]);

  const load = () => {
    axios2
      .post(`/member/delay/list/ready?page=${currPage}&date_type=${$('#date_type option:selected').val() || ''}&s_date=${$('#s_date').val()}&e_date=${$('#e_date').val()}&s_delay_type=&key=${$('#key').val()}`)
      .then((response) => {
        const {code, message, result, pageInfo} = response?.data;
        if (code === 200) {
          setRets(result?.result);
          setPageInfo(pageInfo);
        }
      })
      .catch((error) => {
        if (!window.disableErrorMsg) alert('데이터오류! 시스템 관리자에게 문의하세요');
      });
  }

  //  3-1.
  const make_monitor = () => {
    const as = window.open('/inc/black.html', 'enter_monitor', 'width=0,height=0,scrollbars=yes,top=10000,left=10000');
    as.window.close();
    const as2 = window.open('/enter/enter_monitor.html', 'enter_monitor', 'width=500,height=500,scrollbars=yes,top=600,left=1000');

    return () => {
      as2.close();
    };
  };

  //  4-1.
  const [split, setSplit] = useState("");
  const [re_data, setRe_data] = useState("");
  const [re_cont1, setRe_cont1] = useState("");
  const [re_cont2, setRe_cont2] = useState("");
  const [type, setType] = useState("");
  const form1 = document.getElementById('form1');
  const [searchAuthCode, setSearchAuthCode] = useState("");
  const [authCodeName, setAuthCodeName] = useState("");

  //  5-1.
  const form1a = document.getElementById('form1');
  const [base_seq, setBase_seq] = useState("");
  const take_permit = () => {
    const auth_code = form1.auth_code.value;
    if (auth_code === "") {
      alert('인증코드를 입력해주세요');
      form1.auth_code.focus();
      return;
    }

    if (window.confirm('선택한 연기신청을 승인처리 하시겠습니까?')) {
      form1a.auth_code.value = auth_code;
      form1a.base_seq.value = base_seq;

      const form = $('form')[1];
      const formData = new FormData(form);
      $.ajax({
        url: 'delay_permit.php',
        processData: false,
        contentType: false,
        data: formData,
        type: 'POST',
        success: function (data) {
          data = data.trim();
          if (data === "pre") {
            alert('신청일 이후에 자동/수동 휴회기간이 있습니다');
          } else if (data === "ok") {
            alert("처리되었습니다");
            window.location.reload();
          }
        }
      });
    }
  };

  return (
    <CmnCard onLogout={props.onLogout}>

      <div className="d-flex m-3 fn_search_box">
        <div className="pr-1">
          <select className="form-select" aria-label="Default select example" style={{width: '32%'}} id="date_type">
            <option value="request_date">신청일</option>
            <option value="de_sdate">시작일</option>
          </select>
        </div>
        <div className="pr-1 d-flex">
          <div className="input-group" style={{width: 'auto'}}>
            <JDatePicker className="form-control" aria-describedby="button-addon2" id="s_date"/>
            <p className="mx-2">~</p>
            <JDatePicker className="form-control" aria-describedby="button-addon2" id="e_date"/>
          </div>
        </div>
        <div className="pr-1">
          <input type="text" className="form-control" aria-describedby="button-addon2" placeholder="이름/핸드폰 검색" id="key"/>
        </div>
        <div className="pr-1">
          <button type="button" className="btn btn-sm btn-point px-3" onClick={() => setRenew(Fn.getRenewTime())}>
            검색
          </button>
        </div>
      </div>

      <div className="m-3 table_list">
        {/* 회원목록 */}
        <table className="view-rounded sub_table_border">
          <colgroup>
            <col width="60px"/>
            <col width="*"/>
            <col width="*"/>
            <col width="*"/>
            <col width="*"/>
            <col width="*"/>
            <col width="30%"/>
          </colgroup>

          <tr>
            <th>No</th>
            <th>회원명</th>
            <th>회원번호</th>
            <th>신청일</th>
            <th>시작일</th>
            <th>연기기간</th>
            <th>비고</th>
          </tr>
          {rets && rets.map((ret, i) =>
            <tr>
              <td>{pageInfo.totalArticles - pageInfo.articlesPerPage * (pageInfo.currentPage - 1) - i}</td>
              <td>{ret?.mb_name}</td>
              <td>{ret?.mb_id}</td>
              <td>{(ret?.request_date || '').replace(/-/g, '.').substr(2, 8)}</td>
              <td>{(ret?.de_sdate || '').replace(/-/g, '.').substr(2, 8)}</td>
              <td>{ret?.de_periodM}개월 {ret?.de_period}일</td>
              <td className="text-left">{ret?.de_etc}</td>
            </tr>
          )}
          {(!rets || rets?.length === 0) &&
            <tr>
              <td colSpan={7}>※ 등록된 data가 없습니다.</td>
            </tr>
          }
        </table>
      </div>

      <nav className="p-3 my-4 d-flex justify-content-center border-top">
        <Paging pageInfo={pageInfo} setCurrPage={page => setCurrPage(page)}/>
      </nav>

    </CmnCard>
  );
};

export default MemberDelayList;
